(function($) {

    var themes = {
        init: function() {
            this.initFakeCrop();
            this.initAutocompleteSearch();
            this.initBackToTop();
            this.initToastrOptions();
            this.initProductPriceText();
            this.initToolTip();
            this.initNavigationMobile();
            this.initSubNavigationMobile();
            this.initSearchAside();
            /*this.initToggleBlock();
            this.initOpenSubCategories();*/
            this.initCompare();
            this.initWhishlist();
            this.initAjaxCart();
            this.initAjaxFilter();
            this.initImageShopify();
            this.initProductImageSize();
            this.initCountdownShopify();
            this.initResponsiveVideos();
            this.initBannerHeight();
        },

        initFakeCrop: function() {
            var fakecrop = new FakeCrop();
            var timeoutResize;
            fakecrop.init();
            $(window).resize(function() {
                clearTimeout(timeoutResize);
                timeoutResize = setTimeout(function() {
                    fakecrop.init();
                }, 100);
            });
        },

        initAutocompleteSearch: function() {
            var bestPictures = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: '/search?type=product&q=%QUERY&view=json',
                    wildcard: '%QUERY'
                }
            });
            bestPictures.initialize();
            $('.search-bar-box').typeahead({
                hint: true,
                highlight: true,
                minLength: 1
            }, {
                name: 'best-pictures',
                display: 'title',
                source: bestPictures,
                templates: {
                    suggestion: function(datum) {
                        if (datum) {
                            return '<a href="' + datum.url + '">' + '<span class="thumbnail"><img src="' + datum.thumbnail + '"></span>' + '<span class="title">' + datum.title + '</span>' + '</a>';
                        } else {
                            return '<p></p>';
                        }
                    }
                }
            });
        },

        initBackToTop: function() {
            $("#back-top").hide();
            $(function() {
                $(window).scroll(function() {
                    if ($(this).scrollTop() > 100) {
                        $('#back-top').fadeIn();
                    } else {
                        $('#back-top').fadeOut();
                    }
                });
                $('#back-top a').click(function() {
                    $('body,html').animate({
                        scrollTop: 0
                    }, 800);
                    return false;
                });
            });
        },

        initToastrOptions: function() {
            toastr.options = {
                "closeButton": true,
                "debug": false,
                "newestOnTop": false,
                "progressBar": false,
                "positionClass": "toast-top-center",
                "preventDuplicates": false,
                "onclick": null,
                "showDuration": "200",
                "hideDuration": "500",
                "timeOut": "3000",
                "extendedTimeOut": "500",
                "showEasing": "swing",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut" 
            }; 
        },

        initProductPriceText: function() {
            $('.tp-product-item-price').each(function() {
                $(this).html($(this).html().replace('from', ''));
                $(this).html($(this).html().replace('From', ''))
            });
            $('.tp-product-item-price').has('strong').addClass('tp-has-sale-price');
        },

        initToolTip: function() {
            $('[data-toggle="tooltip"]').tooltip();
        },

        initStickyHeader: function() {
            var scrollTop = $(window).scrollTop();
            var headerSticky = $('header.site-header.header-sticky-enable');
            if (headerSticky.length > 0) {
                if ($(window).width() >= 1300 || $(window).width() < 992) {
                    var heightHeader = headerSticky.outerHeight() + $('.site-header-wrap .breadcrumb').outerHeight();
                    $('.site-header-wrap').css('min-height', heightHeader);
                    if (scrollTop > (heightHeader + 300)) {
                        headerSticky.addClass('sticky fadeInDown');
                    } else {
                        headerSticky.removeClass('sticky fadeInDown');
                    }
                }
                else {
                    $('.site-header-wrap').css('min-height', 0);
                }
            }
        },

        initMegaMenuPosition: function() {
            var $windowWidth = $(window).width();
            if ($windowWidth >= 992) {
                var $dropdownMega = $('.site-nav-horizontal .mega-menu .site-nav-dropdown');
                $dropdownMega.css('width', $windowWidth);
                $dropdownMega.parent().hover(function() {
                    var $container = $(this).find('.site-nav-dropdown');
                    var $nav = $('#PageContainer');
                    $container.position({
                        my: "left",
                        at: "left",
                        of: window
                    });
                    var pad = $nav.offset().left + $nav.outerWidth() - ($container.offset().left + $container.outerWidth());
                    var pad2 = $container.offset().left + pad - $nav.offset().left;
                    console.log(pad);
                    console.log(pad2);
                    if (pad2 < 0) pad = pad - pad2;
                    if (pad < 0){
                        $container.css('left', pad+'px'); 
                    }
                }, function() {
                    $(this).children('.site-nav-dropdown').css('left', '');
                });
            }
        },

        initSearchAside: function() {
            $('.search-aside-wrap .icon-search').click(function(){
                $(this).next('.search-aside').addClass('active');
            });
            $('.search-aside-wrap .icon-close').click(function(){
                $(this).parent('.search-aside').removeClass('active');
            });
        },

        initNavigationMobile: function() {
            if ($(window).width() < 992) {
                var naviWrap = $('.site-header .site-nav-wrapper');
                var closeBtn = $('.tp-menu-mobile .btn-close');
                $('.mobile-navi-toggle').click(function() {
                    naviWrap.addClass('slide-active');
                    setTimeout(function(){
                        $('<div class="site-nav-backdrop"></div>').insertBefore('.site-nav-wrapper');
                        $('.site-nav-backdrop').click(function() {
                            if (naviWrap.hasClass('slide-active')) {
                                naviWrap.removeClass('slide-active');
                            };
                            $('.site-nav-backdrop').remove();
                        });
                    }, 300);
                });

                closeBtn.click(function(){
                    if (naviWrap.hasClass('slide-active')) {
                        naviWrap.removeClass('slide-active');
                    };
                    $('.site-nav-backdrop').remove();
                });

                $('.site-nav-backdrop').click(function() {
                    alert('pop');
                    if (naviWrap.hasClass('slide-active')) {
                        naviWrap.removeClass('slide-active');
                    };
                    $('.site-nav-backdrop').remove();
                });
            }
        },

        initSubNavigationMobile: function() {
            $('.nav-item-link>.icon-plus').click(function() {
                /* Navi Level 1 */
                $(this).parent('.nav-item-link').toggleClass('open');
                $(this).parents('.nav-item').siblings().find('.nav-item-link').removeClass('open');
                $(this).parents('.nav-item').siblings().find('.tp-mega-heading').removeClass('open');
                $(this).parents('.nav-item').siblings().find('.site-nav-dropdown').slideUp();
                $(this).parent('.nav-item-link').next('.site-nav-dropdown').slideToggle();
            });
            /* Navi Level >= 2 */
            $('.tp-mega-heading>.icon-plus').click(function() {
                var parent = $(this).parent('.tp-mega-heading');
                var parentNext = parent.next('.site-nav-dropdown');
                var grandParent = $(this).parents('.site-nav-dropdown');
                grandParent.find('.tp-mega-heading').not(parent).removeClass('open');
                grandParent.find('.site-nav-dropdown').slideUp();
                if (!parent.hasClass('open')) {
                    parent.addClass('open');
                }
                else {
                    parent.removeClass('open');
                }
                if (!parentNext.is(':visible')) {
                    parentNext.slideDown();
                }
                else {
                    parentNext.slideUp();
                }
            });
        },

        initToggleBlock: function() {

            /*  */
            if ($(window).width() < 992) {
                /* Footer Link Toggle on Mobile */
                $('.site-footer .footer-heading').click(function() {
                    $(this).toggleClass('open').next('.footer-toggle-wrap').slideToggle();
                });

                /* Toggle Sidebar On Mobile */
                $('.button-sidebar-toggle').click(function() {
                    $(this).parents('main').find('.tp-sidebar-toggle').toggleClass('slide-left');
                    setTimeout(function(){
                      $('<span class="tp-button-close"></span>').insertBefore('.tp-sidebar-toggle');
                      $('.tp-button-close').click(function(){
                          $(this).next('.tp-sidebar-toggle').removeClass('slide-left');
                          $(this).remove();
                        });
                    }, 500);

                    
                });
            };
        },

        openNewsletterPopup: function() {
            $('#newsletter-modal').fadeIn(500, function() {
               $('#newsletter-modal .modal-window').fadeIn(500);
            });
        },

        closeNewsletterPopup: function() {
            $('#newsletter-modal .modal-window').fadeOut(500, function() {
                $('#newsletter-modal .modal-overlay').fadeOut(500, function() {
                    $('#newsletter-modal').hide();
                    $.cookie('emailSubcribeModal', 'closed', {expires:1, path:'/'});
                });
            })
        },

        initNewsletterPopup: function() {
            /*themes.openNewsletterPopup();*/
            if ($.cookie('emailSubcribeModal') != 'closed') {
                themes.openNewsletterPopup();
            };
            $('#newsletter-modal .btn.close').click(function(e) {
                e.preventDefault();
                themes.closeNewsletterPopup();
            });
            $('#newsletter-modal .modal-overlay').click (function() {
                themes.closeNewsletterPopup();
            });
            $('#mc_embed_signup form').submit(function() {
                if ($('#mc_embed_signup .email').val() != '') {
                    themes.closeNewsletterPopup();
                }
            });
            $('.newsletter-msg').bind('click',function(){
                $('#newsletter-modal').remove();
                $.cookie('popupNewsletterClose', 'closed', {expires:1, path:'/'});
            });
            if ($.cookie('popupNewsletterClose') == 'closed') {
                $('#newsletter-modal').remove();
            }
        },

        initCompare: function() {
            var compare = new Compare(); 
            compare.initCompareSaveProductId();
            compare.initCompareChecked();
        },

        initWhishlist: function() {
            var wishlist = new Wishlist(); 
            wishlist.initWishlistSaveProductId();
            wishlist.initWishlistChecked();
        },

        initAjaxCart: function() {
            var cart = new Cart();
            cart.initAddToCart();
            cart.initRemoveToCart();
        },

        initAjaxFilter: function() {
            var filter = new Filter();
            filter.initAll();
        },

        initImageShopify: function() {
            var imageShopify = new ImageShopify();
            imageShopify.initAll();
        },

        initProductImageSize: function() {
            setTimeout(function () {
                var img = new ImageShopify();
                img.initSetProductHeight();
            }, 1000);
        },

        initCountdownShopify: function() {
            var countDownShopify = new CountDownShopify();
            countDownShopify.initAll();
        },

        initSwatch: function() {
            $('.swatch :radio').change(function() {
                var optionIndex = $(this).closest('.swatch').attr('data-option-index');
                var optionValue = $(this).val();
                $(this)
                  .closest('form')
                  .find('.single-option-selector')
                  .eq(optionIndex)
                  .val(optionValue)
                  .trigger('change');
            });
        },

        initResponsiveVideos: function() {
            var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
            var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
            $iframeVideo.each(function() {
                $(this).wrap('<div class="video-wrapper"></div>');
            });
            $iframeReset.each(function() {
                this.src = this.src;
            });
        },

        initBannerHeight: function() {
            $('.tp-banner-item.has-text').each(function() {
                var img = $(this).find('img'),
                    txt = $(this).find ('.inner');
                if (img.length > 0 && txt.length > 0) {
                    var h_img = img.height(),
                        h_txt = txt.height();
                    if (h_txt > h_img) {
                        $(this).addClass('banner-image-under');
                    }
                    else {
                        $(this).removeClass('banner-image-under');
                    }
                }
            });
        }
        
    };

    $(document).ready(function() {

        themes.init();

    });

    /* Once all Content loaded */
    $(window).load(function() {

        themes.initNewsletterPopup();

        themes.initProductImageSize();
      
      	themes.initToggleBlock();

        /* Swatch Color On Product Page */
        themes.initSwatch();

    });


    /* Once screen window is loaded or scrolled or resized */
    $(window).on('load scroll resize', function() {
        themes.initStickyHeader();
    });

    /* Once screen window is resized */
    $(window).on('load resize', function() {
        themes.initMegaMenuPosition();
        themes.initNavigationMobile();
        themes.initImageShopify();
        themes.initBannerHeight();
    });

    window.images_size = {
        ratio_width : 400,
        ratio_height : 400,
    }

})(jQuery);

